import {getNamesAccounts,getDataAccount} from "../../../helpers/forecast";
import { setAccountsToSelect,setDataInAccount,setStateForecast,setForecastForConsolidated } from "./forecastSlice";



export const getAccountsNames = (body) => {
    return async( dispatch ) => {
        dispatch(setStateForecast('processing'))
        const respJson = await getNamesAccounts({idTenant:body})
        dispatch(setAccountsToSelect(respJson.data))
        dispatch(setStateForecast('ready'))

    }
}

export const getAccountAndDatesById = (user,accountId,cloud,tenantId,accumulated) => {
    return async( dispatch ) => {
        dispatch(setStateForecast('processing'))
        try{
            const respJson = await getDataAccount({idTenant:tenantId,idAccount:accountId,user:user,cloud:cloud,accumulated:accumulated})
            dispatch(setDataInAccount(respJson))
            if(cloud === 'Consolidated'){
                dispatch(setForecastForConsolidated(respJson))
            }
        }catch(error){
            console.error('Error al obtener los datos de forecast:', error)
        }finally{
            dispatch(setStateForecast('ready'))
        }
    }
}
    